var User, addReferrer, fetchUser, my_stuff_layout_template, removeCachedUserData, user_nav_template;

require('../../responsive_menu/frontend/view/responsive_menu');

addReferrer = require('../../../../../core/frontend/shared/userSessionAddReferrer');

user_nav_template = require('../vVERSION.html.mustache');

my_stuff_layout_template = require('../../../components/mystuff.html.mustache');

fetchUser = require('../../../../../src/frontend/helper/user/fetchUser').fetchUser;


/*
 * @public
 */

removeCachedUserData = function() {
  return fetchUser.removeUserData();
};

User = {
  init: function() {
    var ref;
    if (!$('#ls-user-nav').length) {
      return;
    }
    this.translations = (ref = Groupon.LS.translations) != null ? ref.userNav : void 0;
    this.country_US = document.head.getAttribute('data-country') === 'US';
    return this.fetch();
  },
  fetch: function() {
    var error, hasUserData, hasUser_cb, noUser_cb, ref, success, userId;
    noUser_cb = function() {
      addReferrer.init();
    };
    hasUser_cb = (function(_this) {
      return function(res) {
        _this.renderUserNav(res);
        _this.renderMyStuff(res);
        Groupon.Modules.Header.bind();
        delete Groupon.Modules.Header;
      };
    })(this);
    success = hasUser_cb;
    ref = fetchUser.useStoredData(noUser_cb, hasUser_cb), userId = ref.userId, hasUserData = ref.hasUserData;
    if (hasUserData || !userId) {
      return;
    }
    error = function(err) {
      Groupon.Utils.trackEvent('user-call-failed', err);
    };
    return fetchUser.fetch(userId, success, error);
  },
  renderUserNav: function(user) {
    var data, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    data = {
      user: user,
      t: this.translations,
      country_US: this.country_US,
      showLiteHeader: $('#ls-lite-header').length != null,
      enableBigSearch: $('.big-searchbar').length != null,
      showWishlist: ((ref = Groupon.LS.experiments) != null ? ref.showWishlist : void 0) && ($('#ls-lite-header').length != null),
      showMyPageUsersSubnav: (ref1 = Groupon.LS.experiments) != null ? ref1['LS-1237-MyPageUsersSubnav'] : void 0,
      showMerchantLinkHeader: (ref2 = Groupon.LS.flags) != null ? ref2.showMerchantLinkHeader : void 0,
      showReferAFriend: (ref3 = Groupon.LS.flags) != null ? ref3.showReferAFriend : void 0,
      referAFriendMessage: (ref4 = Groupon.LS.flags) != null ? ref4.referAFriendMessage : void 0,
      showMerchantCenterLink: (ref5 = Groupon.LS.flags) != null ? ref5.showMerchantCenterLink : void 0,
      showGiftCards: (ref6 = Groupon.LS.flags) != null ? ref6.showGiftCards : void 0,
      showCart: (ref7 = Groupon.Cart) != null ? ref7.showCart : void 0
    };
    $('#ls-user-nav').html(user_nav_template.render(data));
    addReferrer.init();
    if ((ref8 = Cookie.get('has_cpp')) === '1' || ref8 === 'true') {
      $('#user-my-page').removeClass('hidden');
    }
    if ((ref9 = Groupon.PageFlags) != null ? ref9.isLegacyResponsive : void 0) {
      new Groupon.LS.Header.PNResponsiveMenu;
    }
    $('#sign-out, #ls-resp-sign-out').one('click', fetchUser.removeUserData);
  },
  renderMyStuff: function(user) {
    var $myStuffSelector, current, data, ref, ref1, ref2;
    if (!($myStuffSelector = $('#ls-my-stuff-wrapper')).length) {
      return;
    }
    current = Groupon.LS.CurrentMyStuffApp;
    data = {
      current: current,
      user: user,
      t: this.translations,
      country_US: this.country_US,
      showMyFoodTab: (ref = Groupon.LS.flags) != null ? ref.showMyFoodTab : void 0,
      showMyLinkedDealsTab: (ref1 = Groupon.LS.flags) != null ? ref1.showMyLinkedDealsTab : void 0,
      showMyReservationsTab: (ref2 = Groupon.LS.flags) != null ? ref2.showMyReservationsTab : void 0
    };
    return $myStuffSelector.html(my_stuff_layout_template.render(data));
  }
};

Groupon.LS.User = {
  removeCachedUserData: removeCachedUserData
};

module.exports = {
  User: User
};

